import React from 'react';
import './Partners.css';
import OptimizedImage from './OptimizedImage';
import VisaLogo from 'url:../../assets-optimized/VISA_logo.png';
import VisaLogoAvif from 'url:../../assets-optimized/VISA_logo.avif';
import VisaLogoWebp from 'url:../../assets-optimized/VISA_logo.webp';
import DicksLogo from 'url:../../assets-optimized/Dicks_Logo.png';
import DicksLogoAvif from 'url:../../assets-optimized/Dicks_Logo.avif';
import DicksLogoWebp from 'url:../../assets-optimized/Dicks_Logo.webp';
import PepsiCoLogo from 'url:../../assets-optimized/PepsiCo_Logo.png';
import PepsiCoLogoAvif from 'url:../../assets-optimized/PepsiCo_Logo.avif';
import PepsiCoLogoWebp from 'url:../../assets-optimized/PepsiCo_Logo.webp';
import UALogo from 'url:../../assets-optimized/UALogo.png';
import UALogoAvif from 'url:../../assets-optimized/UALogo.avif';
import UALogoWebp from 'url:../../assets-optimized/UALogo.webp';
import AMEXLogo from 'url:../../assets-optimized/AMEX_logo.png';
import AMEXLogoAvif from 'url:../../assets-optimized/AMEX_logo.avif';
import AMEXLogoWebp from 'url:../../assets-optimized/AMEX_logo.webp';
import StarbucksLogo from 'url:../../assets-optimized/Starbucks_Logo.png';
import StarbucksLogoAvif from 'url:../../assets-optimized/Starbucks_Logo.avif';
import StarbucksLogoWebp from 'url:../../assets-optimized/Starbucks_Logo.webp';
import AudibleLogo from 'url:../../assets-optimized/Audible_Logo.png';
import AudibleLogoAvif from 'url:../../assets-optimized/Audible_Logo.avif';
import AudibleLogoWebp from 'url:../../assets-optimized/Audible_Logo.webp';
import AdobeLogo from 'url:../../assets-optimized/Adobe_Logo.png';
import AdobeLogoAvif from 'url:../../assets-optimized/Adobe_Logo.avif';
import AdobeLogoWebp from 'url:../../assets-optimized/Adobe_Logo.webp';
import partnerHeaderDesktop from 'url:../../assets-optimized/redesign/text/partner_with_us_join_the_network.png';
import partnerHeaderDesktopAvif from 'url:../../assets-optimized/redesign/text/partner_with_us_join_the_network.avif';
import partnerHeaderDesktopWebp from 'url:../../assets-optimized/redesign/text/partner_with_us_join_the_network.webp';
import partnerHeaderMobile from 'url:../../assets-optimized/redesign/text/partner_with_us_join_the_network_mobile.png';
import partnerHeaderMobileAvif from 'url:../../assets-optimized/redesign/text/partner_with_us_join_the_network_mobile.avif';
import partnerHeaderMobileWebp from 'url:../../assets-optimized/redesign/text/partner_with_us_join_the_network_mobile.webp';
import BannerImage from 'url:../../assets-optimized/redesign/slider/high-impact.jpg';
import BannerImageAvif from 'url:../../assets-optimized/redesign/slider/high-impact.avif';
import BannerImageWebp from 'url:../../assets-optimized/redesign/slider/high-impact.webp';

const partnerLogos = [
  { avif: VisaLogoAvif, webp: VisaLogoWebp, fallback: VisaLogo, alt: 'Visa' },
  { avif: PepsiCoLogoAvif, webp: PepsiCoLogoWebp, fallback: PepsiCoLogo, alt: 'PepsiCo' },
  { avif: UALogoAvif, webp: UALogoWebp, fallback: UALogo, alt: 'United Airlines' },
  { avif: AMEXLogoAvif, webp: AMEXLogoWebp, fallback: AMEXLogo, alt: 'American Express' },
  { avif: StarbucksLogoAvif, webp: StarbucksLogoWebp, fallback: StarbucksLogo, alt: 'Starbucks' },
  { avif: DicksLogoAvif, webp: DicksLogoWebp, fallback: DicksLogo, alt: 'Dicks' },
  { avif: AudibleLogoAvif, webp: AudibleLogoWebp, fallback: AudibleLogo, alt: 'Audible' },
  { avif: AdobeLogoAvif, webp: AdobeLogoWebp, fallback: AdobeLogo, alt: 'Adobe' },
];

const Partners = () => {
  const scrollToLogos = () => {
    const element = document.getElementById('partners-logos');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <section className='redesign-partners'>
      <p className='all-caps'>Trusted by the brands shaping modern travel</p>
      <p className='partners-text'>
        We partner with brands to connect with travelers in moments that matter most. Together, we
        create experiences that feel natural to the journey, from inspiration through arrival and
        beyond.
      </p>
      <div className='scroll-down-arrow' onClick={scrollToLogos}>
        <svg viewBox='0 0 24 24'>
          <path d='M12 5v14M5 12l7 7 7-7' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
      </div>
      <div className='logo-container' id='partners-logos'>
        {partnerLogos.map((logo) => (
          <OptimizedImage
            key={logo.alt}
            className='logo-img'
            avif={logo.avif}
            webp={logo.webp}
            fallback={logo.fallback}
            alt={logo.alt}
          />
        ))}
      </div>
      <div className='personalized-banner'>
        <div className='banner-left'>
          <h2>
            Where travel
            <br className='desktop-only' /> insight takes shape
          </h2>
        </div>
        <div className='banner-middle'>
          <p>
            Get the latest on research, product launches, and how we’re shaping the future of
            travel. Follow along on LinkedIn.
          </p>
        </div>
        <div className='banner-right'>
          <OptimizedImage
            className='banner-img'
            avif={BannerImageAvif}
            webp={BannerImageWebp}
            fallback={BannerImage}
            alt='Personalized brand moments'
          />
          <a
            className='banner-linkedin-btn'
            href='https://www.linkedin.com/company/marriott-media/'
            target='_blank'
            rel='noopener noreferrer'
            aria-label='Follow us on LinkedIn (opens in a new tab)'
          >
            <svg
              viewBox='0 0 24 24'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
              aria-hidden='true'
            >
              <circle cx='12' cy='12' r='12' fill='white' />
              <path
                d='M8.25 17.5H5.75V9.5H8.25V17.5ZM7 8.25C6.17 8.25 5.5 7.58 5.5 6.75C5.5 5.92 6.17 5.25 7 5.25C7.83 5.25 8.5 5.92 8.5 6.75C8.5 7.58 7.83 8.25 7 8.25ZM18.5 17.5H16V13.5C16 12.55 15.95 11.25 14.5 11.25C13 11.25 12.75 12.4 12.75 13.4V17.5H10.25V9.5H12.65V10.6H12.7C13.05 9.95 13.9 9.3 15.15 9.3C17.75 9.3 18.5 11 18.5 13.15V17.5Z'
                fill='#1c1c1c'
              />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Partners;
